import constraints from '../../constraints';
import getExtensionControlsForElement from '../../extensions/helpers/get-extension-controls-for-element';
import findAllSelectedFor from '../../element-settings/filters/find-all-selected-for';

const isSelectableElement = (element) => {
  if (constraints.verifiers.canBeInteracted(element)) {
    if (constraints.verifiers.canBeSelected(element)) {
      return true;
    }

    return false;
  }

  if (getExtensionControlsForElement(element).length) {
    return true;
  }

  if (findAllSelectedFor(element).length) {
    return true;
  }

  return false;
};

export default isSelectableElement;
